module.exports = __webpack_public_path__ + "img/no-reports.dc80440e.svg";